export const openInNewTab = (link) =>
  window.open(link, "_blank", "noopener,noreferrer");
